namespace Areas.TreeList {
    "use strict";

    export function addResetLayout(e: any) {
        const treeList: DevExpress.ui.dxTreeList = e.component;

        addButtonToToolbar(e.toolbarOptions, {
            text: "Reset Layout",
            hint: "Reset grid layout",
            type: "normal",
            icon: "revert",
            onClick: reset(treeList)
        }, "after");
    }

    function reset(treeList: DevExpress.ui.dxTreeList) {
        return (e: any) => {
            treeList.state({});
        }
    }
}